import * as React from "react";
import { SVGProps } from "react";
const SvgHomeSetup = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#home-setup_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M25.17 3a1 1 0 0 1 .837.45l.063.11 5.83 12a1 1 0 0 1-.787 1.434L31 17h-4v10a1 1 0 0 1-.883.993L26 28H6a1 1 0 0 1-.993-.883L5 27V17H1a1 1 0 0 1-.949-1.321L.1 15.56l5.83-12a1 1 0 0 1 .774-.552L6.83 3h18.34Zm-.63 2H7.46L2.6 15H7v11h18V15h4.4L24.54 5Zm-8.04 5a.5.5 0 0 1 .5.5v1.126c.368.095.714.24 1.032.428l.796-.797a.498.498 0 0 1 .708 0l.707.707a.498.498 0 0 1 0 .708l-.796.797c.188.318.333.665.427 1.031H21a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1.126a3.98 3.98 0 0 1-.428 1.032l.797.796a.498.498 0 0 1 0 .708l-.707.707a.498.498 0 0 1-.708 0l-.796-.797c-.322.19-.669.334-1.031.428L17 20.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1.126a3.978 3.978 0 0 1-1.031-.427l-.797.796a.498.498 0 0 1-.708 0l-.707-.707a.498.498 0 0 1 0-.708l.797-.796a3.978 3.978 0 0 1-.428-1.031L11 16.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1.126a3.96 3.96 0 0 1 .428-1.032l-.797-.796a.498.498 0 0 1 0-.708l.707-.707a.498.498 0 0 1 .708 0l.796.797c.322-.19.67-.335 1.032-.428V10.5a.5.5 0 0 1 .5-.5h1Zm-.5 3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="home-setup_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeSetup;
